"use client"

import { create } from "zustand"
import { Descope } from "@descope/nextjs-sdk"

interface ImpersonateState {
  stoppingImpersonate: boolean
  handleStopImpersonating: () => void
  resetStoppingImpersonate: () => void
}

export const useImpersonateStore = create<ImpersonateState>((set) => ({
  stoppingImpersonate: false,
  handleStopImpersonating: () => set({ stoppingImpersonate: true }),
  resetStoppingImpersonate: () => set({ stoppingImpersonate: false }),
}))

export function ImpersonateHandler() {
  const stoppingImpersonate = useImpersonateStore((state) => state.stoppingImpersonate)
  const resetStoppingImpersonate = useImpersonateStore((state) => state.resetStoppingImpersonate)

  if (!stoppingImpersonate) {
    return null
  }

  return (
    <Descope
      flowId="stop-impersonate"
      onSuccess={() => {
        resetStoppingImpersonate()
      }}
      onError={(e: any) => {
        console.error("Stop impersonate error:", e.detail)
      }}
      redirectAfterSuccess="/"
    />
  )
}
